const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trade Smarter with Powerful Analytical Tools</h1>
        <p>
          Access top fundamental and technical analysis trading tools with The
          Pips, so you can plan your trades with confidence - anytime, anywhere.
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
